import { Stack, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useCheckoutStore from "../../../stores/public/useCheckoutStore";
import useStorefrontStore from "../../../stores/public/useStorefrontStore";
import OrderSummary from "../../../components/displays/storePages/reservation/checkout/components/OrderSummary";
import { useEffect, useState } from "react";
import show from "../../../api/auth/orders/show";
import WushCard from "../../../components/layout/WushCard";

export default function OrderConfirmation() {
  const { organization } = useStorefrontStore();
  const { order, reservations, reset } = useCheckoutStore();

  const [ stateOrder ] = useState(order);
  const [ stateReservations ] = useState(reservations);

  const navigate = useNavigate();

  useEffect(() => {
    show(order?.id, () => {
      reset();
    });
  }, []);

  if(!stateOrder) {
    navigate(`/storefront/${organization.id}`);
    return null;
  }

  const handleReturnToHome = () => {
    if(organization.homepage_url) {
      window.location = organization.homepage_url;
    } else {
      navigate(`/storefront/${organization.id}`);
    }
  };

  return (
    <Stack>
      <Stack className="hide-print">
        <Typography variant="h4">
          Order Confirmed!
        </Typography>
      </Stack>
      <Stack mb={2} className="hide-print">
        <Typography variant="body1">
          Thank you for shopping with us! You will receive a confirmation email shortly. You may also print this page for your order details.
        </Typography>
      </Stack>
      <Stack direction="row" mb={2} className="hide-print" spacing={2}>
        <Button variant="contained" onClick={() => window.print()}>
          Print
        </Button>
        <Button variant="contained" color="secondary" onClick={handleReturnToHome}>
          Return to Home
        </Button>
      </Stack>
      <WushCard bgcolor={"#ffffff"}>
        <Stack p={2}>
          <OrderSummary order={stateOrder} reservations={stateReservations} showCheckoutButton={false} hideDelete={true}/>
        </Stack>
      </WushCard>
    </Stack>
  );
}